import React from "react";
import "./PayrollAdminTableHeader.scss"; // Copy from AdminTableHeader.scss
import { Box } from "@mui/material";

function PayrollAdminTableHeader({ payrollFilterList, hideTotal }) {
  return (
    <Box className="admin-table-info-header pb-0">
      <Box
        sx={{
          color: "#00365a",
          fontFamily: "Inter",
          fontSize: "16px",
          fontStyle: "normal",
          fontWeight: 700,
          lineHeight: "30px",
        }}
      >
         {!hideTotal && (
        <Box sx={{ color: "#00365a", fontWeight: 700 }}>
          Total: {payrollFilterList?.length || 0} Accounts
        </Box>
      )}
      </Box>
      <Box className="table-options">
        {/* Future enhancements can go here — keeping commented sections for reference */}
        {/* Example: Sort dropdown, filters, etc. */}
        {/* 
        <Select>...</Select>
        <div className="filter-buttons">...</div>
        <Button>Filter</Button>
        */}
      </Box>
    </Box>
  );
}

export default PayrollAdminTableHeader;